<template>
    <div >
      <b-row>
          <b-col md="12">
             <MdTitle v-bind:Text="$t('DrugIssuedByMonthRep.ReportTitle')" />
          </b-col>
      </b-row>
      <b-row>
          <div class="col-sm-12 col-md-12 mb-4">
              <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                  <div class="input-group"  dir="ltr">
                      <input type="text" class="form-control" v-model="parameter.SearchCriteria"
                          @keyup.enter="LoadDrugIssuedByMonth" />

                      <div class="input-group-append">
                          <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                              v-bind:IconClass="'mdi mdi-magnify'" v-on:click="LoadDrugIssuedByMonth">
                          </MdButton>
                      </div>
                  </div>
              </div>
          </div>
      </b-row>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'DrugIssuedByMonthRepDateFrom'"
              :Type="'date'"  
              :OnPressEnter="LoadDrugIssuedByMonth"            
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateFromValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'DrugIssuedByMonthRepDateTo'"
              :OnPressEnter="LoadDrugIssuedByMonth"    
              :Type="'date'"             
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateToValid">
          </MdDateTime>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdLookupMultiSelect
                v-bind:Label="$t('Medication.Drugs')"
                v-bind:ModelCode=DrugsCodeModel
                v-bind:RefCode="'DrugsCode'"
                v-bind:Api="'Drugs'"
                v-bind:FieldCode="'drugCode'"
                v-bind:FieldDescription="'drugname'"
                :SearchTitle="$t('Medication.Drugs')"
                :GetValues="getValuesDrugs"
                :InvalidFeedback="$t('Msg.InvalidCode')"
                :SearchFieldCode="'Code'"
                :AuxFields="AuxFieldsDrugs"
                :ServerSidePagination="true"
                v-bind:Fields="BaseFieldsDrugs"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="true"                      
                :Input="ChangeLocation"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.DrugType')"
              v-bind:Options="DrugTypeList"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"
              v-bind:Model="DrugTypeModel"  
              :Input="ChangeDrugType"
              :SortAlphabetical="true"/>
          </b-col>
          <b-col lg="9" md="9" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadDrugIssuedByMonth"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('DrugIssuedByMonthRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportDrugIssuedByMonthFilters"
          :ReportName="'DrugIssuedByMonth'"
          :ReportTitle="$t('DrugIssuedByMonthRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('DrugIssuedByMonthRep.ReportTitle')"
        v-bind:sendEmailAPI="'/Utils/sendEmail'"
        v-bind:exportCsvAPI="'/DrugIssuedByMonth/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import DBFunctions from '@/common/DBFunctions.js'
  import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
  import UtilsService from '@/services/utils.service'
  import { EventBus } from '@/event-bus.js';
  import Utils from '@/common/utils'
  import StorageService from '@/services/storage.service'
  

  export default Vue.extend({
      name: "DrugIssuedByMonthRep",
      mixins: [ ShowMessage, DBFunctions, PharmacyRepFunctions ],
      components: { DxPopup },
      data() {
          return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom: null,
              dateTo:null,
              lots: '',
              reportParams: [],
              DrugList:[],
              DrugsCodeModel: [],
              LocCodeModel:'',
              LocList:[],
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0       
              },
              params: {
                DrugList: '',
                LocList: '',
                DrugType: ''
              },
              DrugTypeModel: '',
              DrugTypeList: [],
              items: [],         
              fields: [
                { key: 'DrugCode', sortable: true, label: this.$t('Shared.DrugCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('Shared.DrugName'), class: 'text-left' },
                { key: 'YearTransDate', sortable: true, label: this.$t('Shared.year'), class: 'text-center' },
                { key: 'LocationFrom', sortable: true, label: this.$t('Shared.LocationFrom'), class: 'text-left' },
                { key: 'JAN_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.January'), class: 'text-center' },
                { key: 'FEB_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.February'), class: 'text-center' },
                { key: 'MAR_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.March'), class: 'text-center' },
                { key: 'APR_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.April'), class: 'text-center' },
                { key: 'MAY_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.May'), class: 'text-center' },
                { key: 'JUN_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.June'), class: 'text-center' },
                { key: 'JUL_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.July'), class: 'text-center' },
                { key: 'AUG_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.August'), class: 'text-center' },
                { key: 'SEP_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.September'), class: 'text-center' },
                { key: 'OCT_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.October'), class: 'text-center' },
                { key: 'NOV_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.November'), class: 'text-center' },
                { key: 'DEC_QuantityIssued', sortable: true, label: this.$t('Layout.dMonth.December'), class: 'text-center' },
                { key: 'TOTAL_QuantityIssued', sortable: true, label: this.$t('Shared.Total'), class: 'text-center' }
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:[],
              AuxFieldsDrugs:['status'],
              BaseFieldsDrugs:[
                  { key: 'drugname', sortable: true, label: this.$t('Shared.DrugName')},
                  { key: 'activeingred', sortable: true, label: this.$t('Shared.activeIngredients')},
                  { key: 'dosage', sortable: true, label: this.$t('Shared.Dosage')},
                  { key: 'form', sortable: true, label: this.$t('Shared.Form')},
                  { key: 'drugCode', sortable: true, label: this.$t('Shared.DrugCode') },
              ],
              isDateFromValid: true,
              isDateToValid: true,      
          }
      },
      methods: {

          getValuesDrugs: function (value) {
              this.DrugsCodeModel = value
              this.params.DrugList = value.join(',')
          },

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },

          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pDrugList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pLocList',paramValue: this.params.LocList })
            this.reportParams.push({ paramName: 'pDrugType', paramValue: this.params.DrugType})
            this.reportParams.push({ paramName: 'rSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportDrugIssuedByMonthFilters.buildDocument(this.reportParams)
          },

          LoadDrugIssuedByMonth() {
            if (!this.validateForm()) return;

            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
                       this.parameter.DrugList = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : null;
            
            this.parameter.DrugType = this.params.DrugType && this.params.DrugType !== '' 
              ? this.params.DrugType
              : null;
           
            this.parameter.LocList = this.params.LocList && this.params.LocList !== '' 
              ? this.params.LocList
              : null;

            this.parameter.UserId = StorageService.getUserId();
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_WebLetterTemplateDrugIssuedByMonthMultSelection'; 
            this.initializeParameters();

            const spParameters = {
                SearchCriteria: this.parameter.SearchCriteria,
                DrugCode: this.parameter.DrugList,
                IsControlledSubstance: this.parameter.DrugType,
                LocationFrom: this.parameter.LocList,
                DateFrom: this.parameter.DateFrom,
                DateTo: this.parameter.DateTo,
                UserId: this.parameter.UserId
            };
            
            const request = {
                procedureName: procedureName,
                parameters: spParameters,
                pageNumber: this.parameter.PageNumber,
                pageSize: this.parameter.PageSize
            };
          
            UtilsService.getExecuteSP(request)
              .then(response => {
                  if (response.status == "200" && response.data) {
                      this.items = response.data;

                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                      this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                      this.$emit('showEmptyRecords', this.showEmptyRecords);
                  }
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
              });
          },

          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            if (!this.validateForm()) return;

            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            if (!this.validateForm()) return;

            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('DrugIssuedByMonth', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('DrugIssuedByMonth', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          validate_required(){
            const IsValidDateFrom = this.dateFrom ? true : false;
            const IsValidDateTo = this.dateTo ? true : false;
            return IsValidDateFrom  &&  IsValidDateTo; 
          },

          validate_date_range() {
            return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
          },

          // Método de validación reutilizable
          validateForm() {
            const isValid = this.validate_date_range();
       
            this.isDateFromValid = isValid;
            this.isDateToValid = isValid;
            
            // Forzar actualización del componente
            this.$forceUpdate();
            
            if (!isValid) {
              this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
              return false;
            }
            return true;
          },
      },
      
      mounted () {
        this.getLocationsFilter();
        this.getDrugTypeFilter();

        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
